import React, { useState, useRef, useEffect } from "react";
import MyProfile from "./MyProfile/MyProfile";
import UpdatePassword from "./UpdatePassword/UpdatePassword";
import Preference from "./Preference/Preference";
import "./profile.scss";

const tabs = [
  { id: "profile", label: "Profile", Component: MyProfile },
  { id: "password", label: "Security", Component: UpdatePassword },
  { id: "preference", label: "Notification & Preferences", Component: Preference },
];

const keyActions = {
  ArrowRight: (index, last) => (index === last ? 0 : index + 1),
  ArrowLeft: (index, last) => (index === 0 ? last : index - 1),
  Home: () => 0,
  End: (_index, last) => last,
};

const Profile = () => {
  const [activeScreen, setActiveScreen] = useState("profile");
  const tabRefs = useRef([]);

  const handleKeyDown = (e, index) => {
    const lastIndex = tabs.length - 1;
    const action = keyActions[e.key];
    if (!action) return;

    e.preventDefault();
    const newIndex = action(index, lastIndex);
    setActiveScreen(tabs[newIndex].id);
    tabRefs.current[newIndex]?.focus();
  };

  const screenClasses = {
    profile: "myprofileMedia",
    password: "mypasswordMedia",
    preference: "mypreferenceMedia",
  };

  useEffect(() => {
    tabRefs.current[0]?.focus();
  }, []);

  return (
    <div className="profileWrapper main_ele_wrapper">
      <div className="main_heading">
        <h1 id="heading-title">My Account</h1>
      </div>

      <div className="menu_bar tabMenu_bar">
        <ul role="tablist">
          {tabs.map((tab, index) => (
            <li key={tab.id} role="none">
              <button
                id={`tab-${tab.id}`}
                role="tab"
                ref={(el) => (tabRefs.current[index] = el)}
                className={activeScreen === tab.id ? "active" : ""}
                tabIndex={activeScreen === tab.id ? 0 : -1}
                onClick={() => setActiveScreen(tab.id)}
                onKeyDown={(e) => handleKeyDown(e, index)}
              >
                {tab.label}
              </button>
            </li>
          ))}
        </ul>
      </div>

      {tabs.map((tab) => (
        <div
          key={tab.id}
          id={`tabpanel-${tab.id}`}
          role="tabpanel"
          aria-labelledby={`tab-${tab.id}`}
          hidden={activeScreen !== tab.id}
          tabIndex={-1}
          className={`userPassdDetail_wrapper ${screenClasses[tab.id]}`}
        >
          {activeScreen === tab.id && <tab.Component />}
        </div>
      ))}
    </div>
  );
};

export default Profile;
